// extracted by mini-css-extract-plugin
export default {"ckDescription":"AboutUsForm_ckDescription__gtLlx","ckTitle":"AboutUsForm_ckTitle__FLwLf"};